import { render, staticRenderFns } from "./DdjsView.vue?vue&type=template&id=41acee45&scoped=true&"
import script from "./DdjsView.vue?vue&type=script&lang=js&"
export * from "./DdjsView.vue?vue&type=script&lang=js&"
import style0 from "./DdjsView.vue?vue&type=style&index=0&id=41acee45&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41acee45",
  null
  
)

export default component.exports